import { render, staticRenderFns } from "./ReportWhosallersSalesTable.vue?vue&type=template&id=74c58a2b&scoped=true&"
import script from "./ReportWhosallersSalesTable.vue?vue&type=script&lang=js&"
export * from "./ReportWhosallersSalesTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportWhosallersSalesTable.vue?vue&type=style&index=0&id=74c58a2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c58a2b",
  null
  
)

export default component.exports